import type { FC } from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';

interface NpsQuestionBarSegmentProps {
  percentage: number;
  backgroundColor: string;
  borderColor: string;
  color: string;
  absoluteValue: number;
}

const NpsQuestionBarSegment: FC<NpsQuestionBarSegmentProps> = ({
  backgroundColor,
  borderColor,
  percentage,
  color,
  absoluteValue,
}) => (
  <Tooltip title={`n=${absoluteValue}`}>
    <Stack
      sx={[
        {
          alignItems: 'flex-end',
          justifyContent: 'center',
          p: 0.5,
          pt: 0.5,
        },
        {
          width: `${percentage}%`,
          backgroundColor,
          borderBottomWidth: '4px',
          borderBottomStyle: 'solid',
          borderBottomColor: borderColor,
          color,
          textAlign: 'end',
        },
        percentage ? { display: 'flex' } : { display: 'none' },
      ]}
    >
      {percentage > 4 && (
        <Typography variant="caption" sx={{ fontWeight: 600 }}>
          {percentage}%
        </Typography>
      )}
    </Stack>
  </Tooltip>
);

export default NpsQuestionBarSegment;
